<template>
  <div class="driver-stage padding--top-4">
    <div class="row">
      <div class="col-12">
        <div class="driver-stage__number-wrapper text-align--center position-absolute">
          <h2 class="h2 driver-stage__number text-italic primary m-0" v-text="driver.driverNumber"/>
          <h2 class="h2 driver-stage__first-last-name text-italic m-0 position-relative" v-text="`${driver.firstName} ${driver.lastName}`"/>
        </div>
      </div>
    </div>
    <div class="row mt-5 mt-lg-2">
      <div class="col-12">
        <div class="d-flex justify-content-center align-items-center">
          <img v-if="driver.country && driver.country.appCountryFlag"
               class="driver-stage__flag"
               width="48"
               :src="driver.country.appCountryFlag.url"
               :title="driver.country.name"
               :alt="driver.country.name">
          <img v-if="driver.team && driver.team.manufacturer"
               class="driver-stage__team"
               width="60"
               :src="driver.team.manufacturer.imageDark.url"
               :title="driver.team.name"
               :alt="driver.team.name">
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <span class="font-small" v-if="driver.team && driver.team.name" v-text="driver.team.name"/>
        </div>
      </div>
    </div>
    <div class="row bg-white text-default padding--top-4 padding--bottom-4">
      <div class="col-12">
        <div class="driver-stage__career" v-text="driver.appCareer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DriverStage',
  props: {
    driver: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
.driver-stage {

  &__number-wrapper {
    bottom: -60px;
    z-index: 2;
    width: 100%;
    left: 0;
    right: 0;
    height: auto;
  }

  &__number {
    font-size: 14rem;
  }

  &__first-last-name {
    font-size: 4rem;
    top: -70px;
    z-index: 3;
  }

  &__career {
    width: 100%;
    column-count: 2;
    column-gap: 1rem;
    text-align: justify;
  }
}
@media all and (max-width: map_get($grid-breakpoints, 'lg')) {
  .driver-stage {

    &__number-wrapper {
      bottom: -100px;
    }

    &__first-last-name {
      font-size: 3rem;
    }

    &__career {
      column-count: 1;
    }
  }
}
</style>
